import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

import { LaskuReskontra } from '@lemon/core-firebase/model/lasku'

@Component({
  templateUrl: './lasku.reskontra-tiedot.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LaskuReskontraTiedotDialog implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: LaskuReskontra,
    private dialogRef: MatDialogRef<LaskuReskontraTiedotDialog>,
  ) {}

  ngOnInit() {}
}
